export function parseFileSize(mb: number): string {
    const q = Math.floor(mb / 1024)
    return q > 0 ? `${Math.round((mb / 1024) * 100) / 100} GB` : `${mb} MB`
}

export function convertToBytes(mb: number): number {
    return mb * 1024 * 1024
}
